import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListLocationOwnerNameCell } from './emsp-bo-charging-session-list-location-owner-name.cell';
import { EmspBoChargingSessionListLocationOwnerNameHeader } from './emsp-bo-charging-session-list-location-owner-name.header';

export const EmspBoChargingSessionListLocationOwnerNameColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['locationOwnerName']
> = {
  enableSorting: false,
  header: EmspBoChargingSessionListLocationOwnerNameHeader,
  cell: EmspBoChargingSessionListLocationOwnerNameCell,
  meta: { maxWidth: '110px', width: '80px', minWidth: '60px' },
};
